import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import {
  formatAjd,
  processAjdResponse,
} from './utils';

const AJD_URL = `${API_CONFIG.API}/node/ajd`;

export default {
  saveAjd(collaborator) {
    return base.http().post(`${AJD_URL}`, formatAjd(collaborator));
  },
  updateAjd(collaborator) {
    return base.http().patch(`${AJD_URL}/${collaborator.id}`, formatAjd(collaborator));
  },
  getAllAjds() {
    return base.http().get(`${AJD_URL}`)
      .then(res => processAjdResponse(res));
  },
};



// WEBPACK FOOTER //
// ./src/features/ajd/service.js